import { MEDIA_URL } from "src/network/endpoints";

export const PublicRoutes = ["/register", "/login", "/500", "/404", "/home", "/privacy-policy", "/terms-and-conditions"];

export const jsonToFormData = (json) => {
  const formData = new FormData();

  const appendToFormData = (prefix, data) => {
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        const value = data[key];
        const newKey = prefix ? `${prefix}[${key}]` : key;

        if (value instanceof Object) {
          // If the value is an object (but not a file), recursively append its properties
          appendToFormData(newKey, value);
        } else {
          // Otherwise, append the key-value pair
          formData.append(newKey, value);
        }
      }
    }
  };

  // Start the process
  appendToFormData("", json);

  return formData;
};

export default function files(name, type) {
  switch (type) {
    case 'image':
      return name && name.startsWith('http') ? name : `${MEDIA_URL}${name || ''}`;

    case 'file':
      return `${MEDIA_URL}/uploads/files/${name}`;

    case 'audio':
      return `${MEDIA_URL}/uploads/audio/${name}`;

    case 'video':
      return `${MEDIA_URL}/uploads/video/${name}`;

    case 'xlsx':
      return `${MEDIA_URL}/uploads/sampleFile/${name}`;

    case 'attachments':
      return `${MEDIA_URL}/uploads/attachments/${name}`;

    case 'thumb':
      return `${MEDIA_URL}/uploads/attachments/thumb/${name}`;

    default:
      console.log(`${MEDIA_URL}${name}`);
      
      return `${MEDIA_URL}${name}`;
  }
}


//  imgSrc={files(chatUserAvatar, 'image')} example for usage


export function getLastThreeCommaParts(address = '') {
  if (typeof address !== 'string') return '';

  const parts = address.split(',').map(part => part.trim());

  if (parts.length <= 3) {
    return address.trim(); // return full address if 3 or fewer parts
  }

  const lastThree = parts.slice(-3);
  return lastThree.join(', ');
}